import React from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";
import {connect} from "react-redux";
import {claimTypes} from "../../../../constants/claim.constants";

const WidgetDeviceGroupManagement = ({deviceGroups, callbackAction, user, claim, t}) => {

    const claimAccess = user[`c_${claim}`] || null;
    if(claimAccess === claimTypes.NONE) {
        return (
            // return when claims is none
            <React.Fragment/>
        )
    }

    const handleActions = (action, type = "GET") => {
        callbackAction(action, type);
    };

    const groups = deviceGroups?.map((group) => {
        return (
            <div className="list-group-item list-group-item-action" key={group.id}>
                <div className="row">
                    <div className="col-md-3 d-flex">
                        <span className="text-wrap font-weight-bold align-self-center" >{group.label}</span>
                    </div>
                    <div className="col-md-9">
                        <div className="flex-wrap">
                            <Button variant="outline-primary"
                                    size={"sm"}
                                    active={group.manualTurnOn === true}
                                    className="m-1"
                                    disabled={claimAccess === (claimTypes.READ)}
                                    onClick={() => handleActions(`turnonpcgroup/${group.id}`)}>
                                <i className="fas fa-power-off"> </i> &nbsp;
                                <span> { t('turn-on') }</span>
                            </Button>

                            <Button variant="outline-danger"
                                    size={"sm"}
                                    active={group.manualTurnOn === false}
                                    className="m-1"
                                    disabled={claimAccess === (claimTypes.READ)}
                                    onClick={() => handleActions(`turnoffpcgroup/${group.id}`)}>
                                <i className="fas fa-power-off"> </i>
                                <span> { t('turn-off') }</span>
                            </Button>

                            <Button variant="warning"
                                    size={"sm"}
                                    className="m-1"
                                    disabled={claimAccess === (claimTypes.READ)}
                                    onClick={() => handleActions(`RestartPcGroup/${group.id}`)}>
                                <i className="fas fa-undo"/> &nbsp;
                                <span>{ t('Restart') }</span>
                            </Button>

                            <Button variant={"outline-secondary"}
                                    size={"sm"}
                                    className="m-1"
                                    disabled={claimAccess === (claimTypes.READ)}
                                    onClick={() => handleActions(`RestoreScheduleDeviceGroup/${group.id}`, "PATCH")}>
                                <span>{ t('restore-schedule') }</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    });

    return (
        <div className="mt-2">
            { groups?.length ? (
                <div className="card">
                    <div className="card-header">
                        <div className="card-title d-flex w-100">
                            <div className="align-self-center justify-content-between w-100">
                                <b><span className="card-title"> { t('list-device-group') } </span></b>
                                <div className="ml-auto">
                                    <Button variant="outline-success"
                                            size={"sm"}
                                            className="float-right m-1"
                                            disabled={claimAccess === (claimTypes.READ)}
                                            onClick={() => handleActions('RestorePcSchedule')}>
                                        <i className="fas fa-sync"> </i> &nbsp;
                                        { t('restore-schedule') }
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="list-group mx-2">
                            { groups }
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card">
                    <div className="card-header"><span className="card-title"> {t('list-device-group')} </span></div>
                    <div className="card-body">
                        <div className="text-center p-4">
                            <h3>{ t('device-group-no-content') }</h3>
                        </div>
                    </div>
                </div>
            ) }
        </div>
    )
};
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetDeviceGroupManagement))
